// src/slices/FromStatusSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormStatusState {
  [key: string]: number; // Dynamic keys based on form id (e.g., '1', '2', '3', ..., '8')
}

const initialState: FormStatusState = {
  '1': 0,  // Client 1 Details
  '2': 0,  // Client 2 Details
  '3': 0,  // Dependents
  '4': 0,  // Assets - Property
  '5': 0,  // Assets - Non-Property
  '6': 0,  // Assets - Vehicles
  '7': 0,  // Liabilities
  '8': 0,  // Expenses
};

const fromStatusSlice = createSlice({
  name: 'formStatus',
  initialState,
  reducers: {
    setFormStatus: (state, action: PayloadAction<{ id: string; status: number }>) => {
      // Simply set status to 1 when form is "completed"
      if (action.payload.status > 0) {
        state[action.payload.id] = 1;  // Mark the form as completed (status = 1)
      } else {
        state[action.payload.id] = 0;  // No status, form is not completed
      }
    },
  },
});

export const { setFormStatus } = fromStatusSlice.actions;

export default fromStatusSlice.reducer;
